import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { OutletContext } from "../../layouts/DefaultLayout";

const Footer: React.FC = () => {
  const ctx = useContext(OutletContext);

  if (!ctx) return null;

  const { setContactOpen } = ctx;

  return (
    <footer className="bg-gradient-to-b from-[#0B1C33] to-[#081425] text-gray-300 shrink-0 overflow-x-hidden">
      <div className="w-full px-4 sm:px-6 lg:px-12 py-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 items-center gap-4 text-center sm:text-left">

          {/* Left spacer (desktop only) */}
          <div className="hidden sm:block" />

          {/* Center brand */}
          <div className="text-md text-gray-400 text-center whitespace-nowrap">
            © {new Date().getFullYear()} ConsumerCloud. All rights reserved.
          </div>

          {/* Navigation */}
          <nav className="
            flex
            flex-wrap sm:flex-nowrap
            justify-center sm:justify-end
            gap-x-6 gap-y-2
            text-sm text-gray-400
          ">
            <Link to="/terms-and-conditions" className="hover:text-white transition-colors">
              Terms and Conditions
            </Link>
            <Link to="/privacy-policy" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>

            <button
              type="button"
              onClick={() => setContactOpen(true)}
              className="hover:text-white transition-colors"
            >
              Contact us
            </button>

            <Link to="/blogs" className="hover:text-white transition-colors">
              Blogs
            </Link>
            <Link to="/success-stories" className="hover:text-white transition-colors">
              Success Stories
            </Link>
          </nav>

        </div>
      </div>
    </footer>
  );
};

export default Footer;
